(() => {
  const COLOR_MAP = {
    'black':'#111111','white':'#ffffff','green':'#667254','brown':'#6b4a35','coffee':'#6f503e','dark coffee':'#4a352b','khaki':'#b6a47a','beige':'#d8c7a8','apricot':'#d7b08b','cream':'#efe2c9','dark gray':'#55565a','dark grey':'#55565a','gray':'#8d8e91','grey':'#8d8e91','silver grey':'#b8b9bb','silver gray':'#b8b9bb','sapphire blue':'#244a7a','dark blue':'#25354f','navy blue':'#243047','blue':'#466b8f','purplish blue':'#5a5886','purple':'#6f4e7d','brilliant purple':'#7a4f86','grape purple':'#8b456b','rose red':'#a14f63','wine red':'#7b2738','bright red':'#b52b32','red':'#a92e35','yellow':'#e5c94f','lemon yellow':'#eadb57','pink':'#c98e9d','olive':'#73734d','smoke grey':'#6f7376'
  };
  function normalize(v){return (v||'').trim().toLowerCase().replace(/\s+/g,' ')}
  function optionName(fs){
    const legend=fs?.querySelector('legend');
    return (legend?.childNodes?.[0]?.textContent||legend?.textContent||'').trim().toLowerCase();
  }
  function getColorFieldset(root=document){
    return [...root.querySelectorAll('variant-picker fieldset.variant-option')].find(fs=>{
      const name=optionName(fs);
      return name==='color'||name==='colour';
    });
  }
  function colorFor(input,label){
    const key=normalize(input?.value||input?.getAttribute('aria-label'));
    const cssColor=label ? getComputedStyle(label).getPropertyValue('--dos-swatch-color').trim() : '';
    return cssColor||COLOR_MAP[key]||'#d8d1c8';
  }
  function syncGalleryStrip(productInfo){
    const strip=productInfo.querySelector('[data-dos-gallery-color-strip]');
    const fs=getColorFieldset(productInfo);
    if(!strip||!fs) return;
    const inputs=[...fs.querySelectorAll('input[type="radio"]')];
    const checkedIndex=Math.max(0,inputs.findIndex(i=>i.checked));
    strip.querySelectorAll('.dos-mobile-color-swatch').forEach((btn,i)=>{
      btn.setAttribute('aria-pressed',i===checkedIndex?'true':'false');
    });
  }
  function renderGalleryStrip(productInfo){
    const fs=getColorFieldset(productInfo);
    const media=productInfo.querySelector('.product-information__media');
    let strip=productInfo.querySelector('[data-dos-gallery-color-strip]');
    if(!fs||!media){ strip?.remove(); return; }

    fs.classList.add('dos-color-option','dos-color-option--mirrored');
    const inputs=[...fs.querySelectorAll('input[type="radio"]')];
    if(!inputs.length){ strip?.remove(); return; }

    fs.querySelectorAll('.variant-option__button-label').forEach(label=>{
      const input=label.querySelector('input[type="radio"]');
      if(!input) return;
      const value=normalize(input.value||input.getAttribute('aria-label'));
      label.style.setProperty('--dos-swatch-color',COLOR_MAP[value]||getComputedStyle(label).getPropertyValue('--dos-swatch-color').trim()||'#d8d1c8');
      label.title=input.value||input.getAttribute('aria-label')||'Color';
    });

    if(!strip){
      strip=document.createElement('div');
      strip.className='dos-mobile-color-strip dos-gallery-color-strip';
      strip.setAttribute('data-dos-gallery-color-strip','');
      strip.setAttribute('role','group');
      strip.setAttribute('aria-label','Choose a color');
      media.appendChild(strip);
    }

    strip.innerHTML='<span class="visually-hidden">Choose a color</span><div class="dos-mobile-color-strip__swatches"></div>';
    const row=strip.querySelector('.dos-mobile-color-strip__swatches');
    inputs.forEach((input,index)=>{
      const sourceLabel=input.closest('.variant-option__button-label');
      const btn=document.createElement('button');
      btn.type='button';
      btn.className='dos-mobile-color-swatch';
      btn.style.setProperty('--dos-swatch-color',colorFor(input,sourceLabel));
      btn.dataset.inputIndex=String(index);
      btn.setAttribute('aria-label',input.value||input.getAttribute('aria-label')||`Color ${index+1}`);
      btn.setAttribute('title',input.value||input.getAttribute('aria-label')||'Color');
      btn.setAttribute('aria-pressed',input.checked?'true':'false');
      if(input.disabled||input.getAttribute('aria-disabled')==='true') btn.classList.add('is-unavailable');
      btn.addEventListener('click',()=>{
        const current=getColorFieldset(productInfo)?.querySelectorAll('input[type="radio"]')?.[index];
        if(!current) return;
        current.click();
        requestAnimationFrame(()=>syncGalleryStrip(productInfo));
      });
      row.appendChild(btn);
    });
    syncGalleryStrip(productInfo);
  }
  function apply(root=document){
    const productInfos=root.matches?.('.product-information')?[root]:[...root.querySelectorAll?.('.product-information')||[]];
    if(!productInfos.length&&document.querySelector('.product-information')) productInfos.push(document.querySelector('.product-information'));
    productInfos.forEach(renderGalleryStrip);
  }
  apply();
  document.addEventListener('DOMContentLoaded',()=>apply());
  document.addEventListener('variant:update',()=>requestAnimationFrame(()=>apply()));
  document.addEventListener('change',e=>{
    if(e.target.closest?.('.product-information variant-picker')) requestAnimationFrame(()=>{
      const info=e.target.closest('.product-information');
      if(info){renderGalleryStrip(info);syncGalleryStrip(info)}
    });
  });
  new MutationObserver(m=>{
    if(m.some(x=>x.addedNodes.length)) requestAnimationFrame(()=>apply());
  }).observe(document.documentElement,{subtree:true,childList:true});
})();
